var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _g4, _path11, _path12, _g5, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 295,
    viewBox: "0 0 453 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1043_1417)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M318.845 120.193C318.845 120.193 308.749 41.1969 249.186 97.9919C172.829 170.795 121.504 26.0975 64.8604 85.1614C33.9151 117.428 115.688 189.591 61.0752 227.567C6.46257 265.544 51.0909 293.975 51.0909 293.975H361.195C361.195 293.975 393.298 296.293 395.728 255.672C398.154 215.05 360.837 214.558 383.998 163.724C407.158 112.89 326.123 152.549 318.845 120.193Z",
    fill: "url(#paint0_linear_1043_1417)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1043_1417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 70,
    width: 363,
    height: 225
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.853 120.195C318.853 120.195 308.757 41.1988 249.194 97.9938C172.837 170.797 121.511 26.0994 64.8683 85.1634C33.9229 117.43 115.696 189.593 61.083 227.569C6.47038 265.546 51.0988 293.977 51.0988 293.977H361.203C361.203 293.977 393.306 296.295 395.736 255.674C398.162 215.052 360.845 214.56 384.005 163.726C407.166 112.892 326.131 152.551 318.853 120.195Z",
    fill: "url(#paint1_linear_1043_1417)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1043_1417)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 103.73,
    y: 66.3203,
    width: 171.836,
    height: 152.504,
    fill: "url(#paint2_linear_1043_1417)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M94.3003 229.137H285.29L278.321 239.45C278.041 239.865 277.573 240.113 277.073 240.113H102.517C102.017 240.113 101.55 239.865 101.27 239.45L94.3003 229.137Z",
    fill: "url(#paint3_linear_1043_1417)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 83.3237,
    y: 224.748,
    width: 212.942,
    height: 2.19528,
    fill: "url(#paint4_linear_1043_1417)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 79.8613,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 90.8379,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 101.814,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 112.789,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 123.766,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 134.744,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 145.721,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 156.695,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 167.672,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 85.3477,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 96.3242,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 107.301,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 118.277,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 129.254,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 140.229,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 151.205,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 162.184,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.57,
    y: 173.16,
    width: 162.451,
    height: 3.29292,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.156,
    y: 79.8613,
    width: 1.09764,
    height: 110.862,
    fill: "url(#paint5_linear_1043_1417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73 190.376C113.73 189.96 114.067 189.623 114.483 189.623H116.929C117.344 189.623 117.681 189.96 117.681 190.376V193.215H113.73V190.376Z",
    fill: "url(#paint6_linear_1043_1417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.575 193.742C112.674 193.428 112.965 193.215 113.293 193.215H118.116C118.444 193.215 118.735 193.428 118.834 193.742L120.336 198.523C120.489 199.008 120.127 199.501 119.618 199.501H111.791C111.283 199.501 110.92 199.008 111.073 198.523L112.575 193.742Z",
    fill: "url(#paint7_linear_1043_1417)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M444.734 221.395V233.879",
    stroke: "#CFCFCF",
    strokeWidth: 2.46781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M438.484 227.637H450.968",
    stroke: "#CFCFCF",
    strokeWidth: 2.46781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.552 167.481C115.123 167.481 116.397 166.208 116.397 164.636C116.397 163.065 115.123 161.791 113.552 161.791C111.98 161.791 110.707 163.065 110.707 164.636C110.707 166.208 111.98 167.481 113.552 167.481Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.942 284.108C335.789 284.108 383.494 281.144 383.494 277.489C383.494 273.833 335.789 270.869 276.942 270.869C218.095 270.869 170.39 273.833 170.39 277.489C170.39 281.144 218.095 284.108 276.942 284.108Z",
    fill: "#F2F2F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1043_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.865 6.4668H349.613C353.463 6.4668 357.155 7.9962 359.877 10.7186C362.6 13.4409 364.129 17.1332 364.129 20.9832V205.08C364.129 208.93 362.6 212.623 359.877 215.345C357.155 218.067 353.463 219.597 349.613 219.597H175.036C171.186 219.597 167.493 218.067 164.771 215.345C162.048 212.623 160.519 208.93 160.519 205.08V41.161L194.865 6.4668Z",
    fill: "#CEDFFB"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.437 96.1816H203.871V221.371H363.437V96.1816Z",
    fill: "#D2D2D2",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 41.161H188.652C190.303 41.1533 191.883 40.4923 193.047 39.3225C194.212 38.1527 194.865 36.5694 194.865 34.9189V6.4668L160.519 41.161Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1043_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.655 56.2031H204.83C198.689 56.2031 193.71 61.1815 193.71 67.3227V101.088C193.71 107.229 198.689 112.207 204.83 112.207H362.655C368.796 112.207 373.775 107.229 373.775 101.088V67.3227C373.775 61.1815 368.796 56.2031 362.655 56.2031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.655 56.2031H204.83C198.689 56.2031 193.71 61.1815 193.71 67.3227V101.088C193.71 107.229 198.689 112.207 204.83 112.207H362.655C368.796 112.207 373.775 107.229 373.775 101.088V67.3227C373.775 61.1815 368.796 56.2031 362.655 56.2031Z",
    stroke: "#BABABA",
    strokeWidth: 0.0867632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261.85 70.5H220.417C217.777 70.5 215.636 72.6404 215.636 75.2808C215.636 77.9211 217.777 80.0615 220.417 80.0615H261.85C264.491 80.0615 266.631 77.9211 266.631 75.2808C266.631 72.6404 264.491 70.5 261.85 70.5Z",
    fill: "#B4DAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M290.535 88.0586H220.417C217.777 88.0586 215.636 90.199 215.636 92.8394C215.636 95.4797 217.777 97.6201 220.417 97.6201H290.535C293.175 97.6201 295.316 95.4797 295.316 92.8394C295.316 90.199 293.175 88.0586 290.535 88.0586Z",
    fill: "#DEE9FC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1043_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.655 118.27H204.83C198.689 118.27 193.71 123.248 193.71 129.389V163.154C193.71 169.295 198.689 174.274 204.83 174.274H362.655C368.796 174.274 373.775 169.295 373.775 163.154V129.389C373.775 123.248 368.796 118.27 362.655 118.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.655 118.27H204.83C198.689 118.27 193.71 123.248 193.71 129.389V163.154C193.71 169.295 198.689 174.274 204.83 174.274H362.655C368.796 174.274 373.775 169.295 373.775 163.154V129.389C373.775 123.248 368.796 118.27 362.655 118.27Z",
    stroke: "#BABABA",
    strokeWidth: 0.0867632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.85 132.465H220.417C217.777 132.465 215.636 134.605 215.636 137.246C215.636 139.886 217.777 142.026 220.417 142.026H261.85C264.491 142.026 266.631 139.886 266.631 137.246C266.631 134.605 264.491 132.465 261.85 132.465Z",
    fill: "#B4DAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M290.535 150.023H220.417C217.777 150.023 215.636 152.164 215.636 154.804C215.636 157.445 217.777 159.585 220.417 159.585H290.535C293.175 159.585 295.316 157.445 295.316 154.804C295.316 152.164 293.175 150.023 290.535 150.023Z",
    fill: "#DEE9FC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1043_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.655 180.375H204.83C198.689 180.375 193.71 185.353 193.71 191.495V225.26C193.71 231.401 198.689 236.379 204.83 236.379H362.655C368.796 236.379 373.775 231.401 373.775 225.26V191.495C373.775 185.353 368.796 180.375 362.655 180.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.655 180.375H204.83C198.689 180.375 193.71 185.353 193.71 191.495V225.26C193.71 231.401 198.689 236.379 204.83 236.379H362.655C368.796 236.379 373.775 231.401 373.775 225.26V191.495C373.775 185.353 368.796 180.375 362.655 180.375Z",
    stroke: "#BABABA",
    strokeWidth: 0.0867632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M261.85 194.439H220.417C217.777 194.439 215.636 196.58 215.636 199.22C215.636 201.861 217.777 204.001 220.417 204.001H261.85C264.491 204.001 266.631 201.861 266.631 199.22C266.631 196.58 264.491 194.439 261.85 194.439Z",
    fill: "#B4DAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M290.535 211.998H220.417C217.777 211.998 215.636 214.138 215.636 216.779C215.636 219.419 217.777 221.56 220.417 221.56H290.535C293.175 221.56 295.316 219.419 295.316 216.779C295.316 214.138 293.175 211.998 290.535 211.998Z",
    fill: "#DEE9FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1043_1417",
    x: 149.382,
    y: 0.898042,
    width: 225.885,
    height: 235.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.56876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.56876
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_1417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1043_1417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1043_1417",
    x: 182.529,
    y: 50.5914,
    width: 202.426,
    height: 78.3649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.56876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.56876
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_1417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1043_1417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1043_1417",
    x: 182.529,
    y: 112.658,
    width: 202.426,
    height: 78.3649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.56876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.56876
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_1417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1043_1417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1043_1417",
    x: 182.529,
    y: 174.763,
    width: 202.426,
    height: 78.3649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.56876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.56876
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_1417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1043_1417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_1417",
    x1: 33.9136,
    y1: 70.6133,
    x2: 188.694,
    y2: 380.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AACBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_1417",
    x1: 33.9214,
    y1: 70.6152,
    x2: 188.702,
    y2: 380.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AACBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1043_1417",
    x1: -55.755,
    y1: 385.29,
    x2: 86.9905,
    y2: 20.0138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1043_1417",
    x1: -49.4202,
    y1: 225.792,
    x2: 35.5157,
    y2: 415.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1043_1417",
    x1: 111.289,
    y1: 224.786,
    x2: 112.518,
    y2: 244.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1043_1417",
    x1: 114.33,
    y1: 46.0749,
    x2: 117.124,
    y2: 46.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1043_1417",
    x1: 114.249,
    y1: 189.685,
    x2: 119.941,
    y2: 190.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1043_1417",
    x1: 112.063,
    y1: 193.324,
    x2: 125.834,
    y2: 196.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1043_1417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 362.262,
    height: 223.498,
    fill: "white",
    transform: "translate(33.9136 70.6133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecords);
export default __webpack_public_path__ + "static/media/no-records.8bc994981808076c24fd56fa4ed1ccab.svg";
export { ForwardRef as ReactComponent };